const server = "https://merry-video-call-website.onrender.com";

export default server;
